module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset> ';
 if ( migrate ) { 
__p+=' <legend>'+
((__t=( i18n.tc("CreateCustomer", "Please make sure this information is correct") ))==null?'':__t)+
'</legend> ';
 } else { 
__p+=' <legend>'+
((__t=( i18n.tc("CreateCustomer", "Create new billing account") ))==null?'':__t)+
'</legend> ';
 } 
__p+=' <div><label for="customer-type-input"><span class="error">*</span>'+
((__t=( i18n.tc("CreateCustomer", "Customer type:") ))==null?'':__t)+
'</label> <select id="customer-type-input" data-input="customer-type"><option value="PRIVATE" '+
((__t=( ( type === "PRIVATE" ) ? "selected" : "" ))==null?'':__t)+
'>'+
((__t=( i18n.tc("CreateCustomer", "Private") ))==null?'':__t)+
'</option><option value="COMPANY" '+
((__t=( ( type === "COMPANY" ) ? "selected" : "" ))==null?'':__t)+
'>'+
((__t=( i18n.tc("CreateCustomer", "Company") ))==null?'':__t)+
'</option></select></div></fieldset><fieldset class="type-private-only"><div><label for="customer-first-name-input"><span class="error">*</span>'+
((__t=( i18n.tc("CreateCustomer", "First name:") ))==null?'':__t)+
'</label> <input type="text" id="customer-first-name-input" data-input="customer-first-name" value="'+
((__t=( firstName ))==null?'':__t)+
'" required></div><div><label for="customer-last-name-input"><span class="error">*</span>'+
((__t=( i18n.tc("CreateCustomer", "Last name:") ))==null?'':__t)+
'</label> <input type="text" id="customer-last-name-input" data-input="customer-last-name" value="'+
((__t=( lastName ))==null?'':__t)+
'" required></div></fieldset><fieldset class="type-private-only"><div><label for="customer-birth-date">'+
((__t=( i18n.tc("CreateCustomer", "Date of birth:") ))==null?'':__t)+
'</label><div class="input"><select class="col-3" id="customer-birth-date" data-input="customer-birth-date-day"><option value="">'+
((__t=( i18n.tc("CreateCustomer", "Day") ))==null?'':__t)+
'</option></select> <select class="col-3" data-input="customer-birth-date-month"><option value="">'+
((__t=( i18n.tc("CreateCustomer", "Month") ))==null?'':__t)+
'</option></select> <select class="col-3" data-input="customer-birth-date-year"><option value="">'+
((__t=( i18n.tc("CreateCustomer", "Year") ))==null?'':__t)+
'</option></select></div></div></fieldset><fieldset class="type-company-only"><div><label for="customer-company-name-input"><span class="error">*</span>'+
((__t=( i18n.tc("CreateCustomer", "Company name:") ))==null?'':__t)+
'</label> <input type="text" id="customer-company-name-input" data-input="customer-company-name" value="'+
((__t=( companyName ))==null?'':__t)+
'"></div><div><label for="customer-company-number-input"><span class="error">*</span>'+
((__t=( i18n.tc("CreateCustomer", "Company number:") ))==null?'':__t)+
'</label> <input type="text" id="customer-company-number-input" data-input="customer-company-number" value="'+
((__t=( companyNumber ))==null?'':__t)+
'"></div></fieldset><fieldset><div><label for="customer-contact-mail-input"><span class="error">*</span>'+
((__t=( i18n.tc("CreateCustomer", "Contact email:") ))==null?'':__t)+
'</label> <input type="text" id="customer-contact-mail-input" data-input="customer-contact-mail" value="'+
((__t=( contactEmail ))==null?'':__t)+
'" required></div></fieldset><fieldset><div><label for="customer-address-1"><span class="error">*</span>'+
((__t=( i18n.tc("CreateCustomer", "Address 1:") ))==null?'':__t)+
'</label> <input type="text" id="customer-address-1" data-input="customer-address-1" value="'+
((__t=( address1 ))==null?'':__t)+
'" required></div><div><label for="customer-address-2">'+
((__t=( i18n.tc("CreateCustomer", "Address 2:") ))==null?'':__t)+
'</label> <input type="text" id="customer-address-2" data-input="customer-address-2" value="'+
((__t=( address2 ))==null?'':__t)+
'"></div><div class="clearfix"><div class="narrow"><label for="customer-postcode-input"><span class="error">*</span>'+
((__t=( i18n.tc("CreateCustomer", "Post code:") ))==null?'':__t)+
'</label> <input type="text" id="customer-postcode-input" data-input="customer-postcode" value="'+
((__t=( postcode ))==null?'':__t)+
'" required></div><div class="wide"><label for="customer-city-input"><span class="error">*</span>'+
((__t=( i18n.tc("CreateCustomer", "City:") ))==null?'':__t)+
'</label> <input type="text" id="customer-city-input" data-input="customer-city" value="'+
((__t=( city ))==null?'':__t)+
'" required></div></div><div><label for="customer-country-input"><span class="error">*</span>'+
((__t=( i18n.tc("CreateCustomer", "Country:") ))==null?'':__t)+
'</label> <select id="customer-country-input" data-input="customer-country" required><option value="">'+
((__t=( i18n.tc("CreateCustomer", "Choose a country") ))==null?'':__t)+
'</option></select></div></fieldset><fieldset><div><label for="customer-invoice-input"><span class="error">*</span>'+
((__t=( i18n.tc("CreateCustomer", "Invoice:") ))==null?'':__t)+
'</label> <select id="customer-invoice-input" data-input="customer-invoice"><option value="EMAIL" '+
((__t=( ( _.contains( invoiceTypes, "EMAIL" ) ) ? " checked" : "" ))==null?'':__t)+
'>'+
((__t=( i18n.tc("CreateCustomer", "Email") ))==null?'':__t)+
'</option><option value="PAPER" '+
((__t=( ( _.contains( invoiceTypes, "PAPER" ) ) ? " checked" : "" ))==null?'':__t)+
'>'+
((__t=( i18n.tc("CreateCustomer", "Paper mail") ))==null?'':__t)+
'</option></select></div><div class="invoice-email-only"><label for="customer-invoice-email-input"><span class="error">*</span>'+
((__t=( i18n.tc("CreateCustomer", "Invoice email:") ))==null?'':__t)+
'</label> <input type="text" id="customer-invoice-email-input" data-input="customer-invoice-email" value="'+
((__t=( invoiceEmail ))==null?'':__t)+
'" required></div></fieldset><fieldset class="button-wrap"><button data-click="customer-cancel">'+
((__t=( i18n.tc("CreateCustomer", "Cancel") ))==null?'':__t)+
'</button> <button class="primary" data-click="customer-submit" disabled="disabled">'+
((__t=( i18n.tc("CreateCustomer", "Create") ))==null?'':__t)+
'</button></fieldset><fieldset><small><span class="error">*</span>'+
((__t=( i18n.tc("CreateCustomer", ": Required information") ))==null?'':__t)+
'</small></fieldset>';
}
return __p;
};
